// extracted by mini-css-extract-plugin
export default {"search-form":"styles_search-form__VlMXD"};